// extracted by mini-css-extract-plugin
module.exports = {"container":"Lq","productName":"Mq","modal":"Nq","dimensions":"Oq","recipientEmail":"Pq","lowStock":"Qq","recommendedFit":"Rq"};